import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-usecases-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
 export class UsecaseBenefitsSectionComponent implements OnInit, OnChanges {
  @Input() benefitsData:any;
  featuresData: any;

  private updateFeaturesData(): void {
    const data = this.benefitsData ?? null;
    if (data) {
      this.featuresData = data;
    }
  }

  ngOnInit(): void {
    this.updateFeaturesData();
  }
  ngOnChanges(): void {
    this.updateFeaturesData();
  }
}
